app.service('productTabWarranties', function(
	cartManager,
	productCardConfig,
	flatWarrantyManager,
	modal,
	broker
) {
	let $self;
	let activeOutletCategoryId;
	let config;
	let currentItemId;
	let $warrantyButtons;

	function isCurrentItemInCart() {
		return $.inArray(parseInt(currentItemId), cartManager.getElements()) !== -1;
	}

	function isWarrantyInCart(warrantyId, warrantyPaymentType) {
		const warranty = cartManager.getWarranty(currentItemId);

		if (!warranty) return false;

		return (
			parseInt(warrantyId) === parseInt(warranty.warrantyId) &&
			warranty.warrantyPaymentType === warrantyPaymentType
		);
	}

	function removeWarrantyFromCart(warrantyId) {
		cartManager.removeWarranty({
			warrantyId,
			productId: config.id,
			warrantyName: ''
		});
	}

	function addWarrantyToCart({ warrantyId, warrantyPaymentType, addedFrom }) {
		cartManager.addWarranty({
			productId: config.id,
			addedFrom,
			warrantyId,
			warrantyPaymentType
		});
	}

	function unselectActiveWarranty() {
		$warrantyButtons.filter(':checked').prop('checked', false);
	}

	function selectWarranty(warrantyData) {
		const { warrantyId, warrantyPaymentType, checked } = warrantyData;

		updateWarranties(warrantyData);

		if (!isCurrentItemInCart()) return;

		if (isWarrantyInCart(warrantyId, warrantyPaymentType)) {
			removeWarrantyFromCart(warrantyId);
		} else {
			checked && addWarrantyToCart(warrantyData);
		}
	}

	function updateWarranties({ warrantyId, warrantyPaymentType, checked }) {
		$warrantyButtons
			.filter(`[value=${warrantyId}]`)
			.filter(`[data-warranty-payment-type=${warrantyPaymentType}]`)
			.prop('checked', checked);
	}

	function updateSelectedWarrantyOnCartChange() {
		const { warrantyId, warrantyPaymentType } = cartManager.getWarranty(
			currentItemId
		);

		if (!warrantyId) {
			unselectActiveWarranty();
			return false;
		}

		updateWarranties({ warrantyId, warrantyPaymentType, checked: true });
	}

	function handleAddWarrantyClick() {
		const warrantyPaymentType = $(this).data('warranty-payment-type');
		const warrantyPeriod = $(this).data('period');
		const addedFrom = $(this).data('addedFrom');
		const warrantyId = $(this).val();
		const checked = $(this).is(':checked');


		broker.trigger('WARRANTY_PAYMENT_TYPE_CHANGE', [
			warrantyPaymentType,
			warrantyId,
			warrantyPeriod
		]);

		unselectActiveWarranty();

		selectWarranty({
			warrantyId,
			warrantyPaymentType,
			checked,
			addedFrom
		});

		if (checked) modal.close();
	}

	function setEvents() {
		$('body').on('change', '.js-add-warranty-checkbox', handleAddWarrantyClick);

		$('body').on('change', '.js-product-for-sale-add-warranty', handleAddWarrantyClick);

		$(document).on('cartReady', function() {
			updateSelectedWarrantyOnCartChange();
		});
	}

	function reload({ productId, outletCategoryId }) {
		return $.ajax({
			url: '/product-card-warranties.ltr',
			data: {
				productId,
				outletCategoryId
			}
		})
			.then(html => {
				$self.replaceWith(html);
				activeOutletCategoryId = outletCategoryId;
				init();
			})
			.fail(() => modal.alert('Błąd pobierania zakładki gwarancje.'));
	}

	function setElements() {
		config = productCardConfig.getData();
		currentItemId = config.id;

		$self = $('#warranties .warranties-container');
		$warrantyButtons = $('.js-add-warranty-checkbox, .js-product-for-sale-add-warranty');
	}

	function init() {
		setElements();
		setEvents();

		$self.find('.select3-input').select3();

		const data = {
			outletCategoryId: activeOutletCategoryId,
			updateWarrantyButtons: updateSelectedWarrantyOnCartChange
		};

		flatWarrantyManager.init(data);
	}

	return {
		init,
		reload
	};
});
